import Grid from "@mui/material/Grid";
import { useTheme } from "@mui/material/styles";

import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import ReportsBarChart from "examples/Charts/BarCharts/ReportsBarChart";
import ReportsLineChart from "examples/Charts/LineCharts/ReportsLineChart";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";

import reportsBarChartData from "layouts/dashboard/data/reportsBarChartData";
import reportsLineChartData from "layouts/dashboard/data/reportsLineChartData";
import Projects from "layouts/dashboard/components/Projects";
import OrdersOverview from "layouts/dashboard/components/OrdersOverview";

function Dashboard() {
  const { sales, tasks } = reportsLineChartData;
  const theme = useTheme();

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox
        py={3}
        px={2}
        sx={{
          borderRadius: "16px",
          transition: "all 0.3s ease",
          boxShadow:
            theme.palette.mode === "dark"
              ? "0 0 12px rgba(0,0,0,0.4)"
              : "0px 4px 24px rgba(0,0,0,0.05)",
        }}
      >
        {/* Stats cards */}
        <Grid container spacing={3}>
          <Grid item xs={12} md={6} lg={3}>
            <ComplexStatisticsCard
              color="dark"
              icon="weekend"
              title="Bookings"
              count={281}
              percentage={{ color: "success", amount: "+55%", label: "than last week" }}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <ComplexStatisticsCard
              icon="leaderboard"
              title="Today's Users"
              count="2,300"
              percentage={{ color: "success", amount: "+3%", label: "than last month" }}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <ComplexStatisticsCard
              color="success"
              icon="store"
              title="Revenue"
              count="34k"
              percentage={{ color: "success", amount: "+1%", label: "than yesterday" }}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <ComplexStatisticsCard
              color="primary"
              icon="person_add"
              title="Followers"
              count="+91"
              percentage={{ color: "success", amount: "", label: "Just updated" }}
            />
          </Grid>
        </Grid>

        {/* Charts */}
        <MDBox mt={4.5}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6} lg={4}>
              <ReportsBarChart
                color="info"
                title="Website Views"
                description="Last Campaign Performance"
                date="campaign sent 2 days ago"
                chart={reportsBarChartData}
              />
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <ReportsLineChart
                color="success"
                title="Daily Sales"
                description="(+15%) increase in today sales."
                date="updated 4 min ago"
                chart={sales}
              />
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <ReportsLineChart
                color="dark"
                title="Completed Tasks"
                description="Last Campaign Performance"
                date="just updated"
                chart={tasks}
              />
            </Grid>
          </Grid>
        </MDBox>

        {/* Bottom section */}
        <MDBox mt={4}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6} lg={8}>
              <Projects />
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <OrdersOverview />
            </Grid>
          </Grid>
        </MDBox>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Dashboard;
